import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./paymentpayhere.scss"

function PayhereSucces() {
  const navigate =useNavigate()
    useEffect(() => {
      const timer = setTimeout(() => {
       navigate("/");
      }, 5000);
  
      return () => clearTimeout(timer);
    }, [navigate]);

  const onNavigate = () => {
     navigate("/");
  };
  return (
    <div className="pyment_success">
      <h1>Payhere Succes</h1>
      <button onClick={() => onNavigate}>go to dashboard</button>
    </div>
  );
}

export default PayhereSucces;
